// ===========================================================================
// CDCI — Clinical Documentation & Charge Intelligence
// Constantes del módulo (docs/modulos/BillingV2/02_CDCI_Descripcion_Modulo.md)
//
// NOTA: catálogos hardcodeados mientras el backend expone los maestros mdm.*
// (mdm.TAB_AMD_LOCATIONS, APPOINTMENT_TYPE, APPOINTMENT_STATUS — Paso 1 del
// roadmap). Cuando existan, estos se cargan vía GET api/amd/locations etc.
// ===========================================================================

export const CDCI_BASE_PATH = "/cdci";

// Nombre completo del módulo: la sigla sola no se entiende fuera del equipo,
// así que las páginas la muestran siempre expandida en el header.
export const CDCI_FULL_NAME = "Clinical Documentation & Charge Intelligence";

// Estados de cita (futuro maestro mdm APPOINTMENT_STATUS)
export const APPT_STATUS = {
  SCHEDULED:   { key: "SCHEDULED",   label: "Scheduled",    tone: "muted" },
  CONFIRMED:   { key: "CONFIRMED",   label: "Confirmed",    tone: "info" },
  CHECKED_IN:  { key: "CHECKED_IN",  label: "Checked in",   tone: "info" },
  IN_ROOM:     { key: "IN_ROOM",     label: "In room",      tone: "warn" },
  COMPLETED:   { key: "COMPLETED",   label: "Completed",    tone: "ok" },
  NO_SHOW:     { key: "NO_SHOW",     label: "No show",      tone: "crit" },
  CANCELLED:   { key: "CANCELLED",   label: "Cancelled",    tone: "muted" },
};

// Tipos de cita con color (futuro maestro getappttypes)
export const APPT_TYPES = {
  AWV:        { key: "AWV",        label: "Annual Wellness", color: "#1B5FA8" },
  FOLLOW_UP:  { key: "FOLLOW_UP",  label: "Follow Up",       color: "#0F6E6E" },
  TELEHEALTH: { key: "TELEHEALTH", label: "Telehealth",      color: "#7B5EA7" },
  HOSP_FU:    { key: "HOSP_FU",    label: "Hospital D/C FU", color: "#B5760A" },
  SICK:       { key: "SICK",       label: "Sick Visit",      color: "#C0392B" },
};

// Ciclo de vida de la nota del encuentro (entidad Note — Paso 4 del roadmap)
export const NOTE_STATUS = {
  NOT_STARTED: { key: "NOT_STARTED", label: "Not started", tone: "muted" },
  DRAFT:       { key: "DRAFT",       label: "Draft",       tone: "warn" },
  COMPLETE:    { key: "COMPLETE",    label: "Complete",    tone: "info" },
  // La clave interna sigue siendo SIGNED (todo el módulo la referencia), pero
  // el label visible es "Closed": en CDCI NO se firman notas — el cierre es
  // local y la firma oficial ocurre en AdvancedMD.
  SIGNED:      { key: "SIGNED",      label: "Closed",      tone: "ok" },
};

// Ciclo de vida de los cargos del encuentro (entidad Charge — Paso 5)
export const CHARGE_STATUS = {
  NOT_CAPTURED: { key: "NOT_CAPTURED", label: "Not captured", tone: "muted" },
  DRAFT:        { key: "DRAFT",        label: "Draft",        tone: "warn" },
  CAPTURED:     { key: "CAPTURED",     label: "Captured",     tone: "ok" },
};

// Pasos del journey del médico (§2 del documento maestro)
export const JOURNEY_STEPS = [
  { key: "schedule", label: "Schedule" },
  { key: "context",  label: "Patient Context" },
  { key: "note",     label: "Documentation" },
  { key: "charges",  label: "Charge Capture" },
  // "Close", no "Sign & Close": en CDCI no se firma — la firma es en AMD.
  { key: "sign",     label: "Close" },
];

// Tabs del workspace del encuentro
export const ENCOUNTER_TABS = {
  CONTEXT: "context",
  NOTE: "note",
  CHARGES: "charges",
  SIGN: "sign",
};

// Causas de visita — mismas opciones que el flujo AI Clinical Notes del
// Patient Map. Deciden el camino de la nota:
// - Sick / accidente / pre-op → nota normal (visita puntual).
// - Rutina / seguimiento / otro → el sistema ofrece los care gaps y coding
//   opportunities pendientes del paciente con asistencia IA.
export const REASON_OF_VISIT_OPTIONS = [
  "Sick",
  "Motor Vehicle Accident (MVA)",
  "Work Accident",
  "Pre-Op / Cosmetic - Surgical",
  "Annual or Lab Follow-Up",
  "Other",
];

// Razones que documentan la nota "normal", sin ofrecer gaps/coding por IA.
export const AI_SKIP_REASONS = new Set([
  "Sick",
  "Motor Vehicle Accident (MVA)",
  "Work Accident",
  "Pre-Op / Cosmetic - Surgical",
]);

/**
 * Review de cobertura (care gaps & coding ops vs nota) — DESACTIVADO mientras
 * el backend no implemente POST /api/dev/review-note (contrato propuesto en
 * docs/modulos/CDCI/CONTRATO_REVIEW_NOTE_CDCI.md).
 *
 * Con el flag en false no se muestra el panel de review en Documentación ni se
 * exige el gate en Sign & Close: las notas se almacenan y firman sin review.
 * Al desplegarse el endpoint, poner true — todo el circuito (panel, declines,
 * gate duro) ya está construido y queda activo con este único cambio.
 */
export const COVERAGE_REVIEW_ENABLED = false;
